<template>
  <L1>
    <template slot="slot_title">
      <RT :options="['用量管理', '訊息設定']" :defaultValue="page" @input="page=$event"></RT>
    </template>
    <div class="editCubebox" v-if="page==='訊息設定'">
      <div>
      <editCube :title="'會員驗證'" :keyname="'memberVerify'"
      :template="`【成美文化園】親愛的會員，您的註冊手機驗證碼為:{OTP}。(注意:驗證碼10分鐘內有效)`"/>
      <!-- <editCube :title="'餐廳預約成功'" :keyname="'restaurantBookSuccess'"
      :template="`【成美文化園】您好，感謝您預訂松柏軒景觀餐廳 {預約日期}，{預約時間}，{人數}人。當日座位將保留十分鐘，祝用餐愉快，期待您的蒞臨，謝謝。請勿回覆此簡訊。`"/> -->
      </div>
      <hr>
      <div>
      <editCube :title="'抓週預約成功'" :keyname="'BabyBookSuccess'"
      :template="`【成美文化園】
您好，感謝您預約成美周晬禮讚 {預約日期}，{預約時間}，{大人小孩}。

兆豐017南京東路分行，
帳號 :07009002016，
本次預購訂金為$3800。

第5位成人(13歲以上)起加收$200元/人，現場結帳計費。
請於預約後72小時內匯款預購完成，並請拍照留存與來電通知已付款，始為報名成功。
若有疑問可來電/FB粉絲專頁洽詢小編，04-8221166#100，請勿回覆此簡訊。`"/>
      <editCube :title="'抓週匯款完成'" :keyname="'BabyPrepaidSuccess'"
      :template="`【成美文化園】
您好， 成美周晬禮讚 {預約日期}，{預約時間}，{大人小孩}。$3880
繳款已確認，當日報到地點於「東園區售票處」(停車場內售票亭)，請提早15分鐘
到達報到，以利加速報到程序。當日加購結帳接受現金、信用卡，臨時增加家屬以
當場實際出席人數收費。期待您的蒞臨，謝謝。請勿回覆此簡訊。`"/>
      </div>
    </div>
    <div v-else class="remainText">
      <div>
        <div>LINE Official</div>
        <div>
          <div>預設上限: {{line.limit.value}} 則</div>
          <div>已傳送則數: {{line.used}} 則</div>
          <div :style="{marginTop:'1em'}">剩餘則數: <span :style="{fontSize: '32px', fontWeight: 700, marginInline: '10px', letterSpacing:'3.2px'}">{{line.limit.value - line.used}}</span> 則</div>
        </div>
      </div>
      <div>
        <div>三竹簡訊 <a :href="data.url" target="_blank">前往官網</a> </div>
        <div>
          <div>上月傳送則數: {{data.used0}} 則</div>
          <div>本月傳送則數: {{data.used1}} 則</div>
          <div :style="{marginTop:'1em'}">剩餘點數: <span :style="{fontSize: '32px', fontWeight: 700, marginInline: '10px', letterSpacing:'3.2px'}">{{data.remain}}</span>點</div>
        </div>
      </div>
    </div>
  </L1>
</template>

<script>
import RT from '../components/radio/r1.vue'
import editCube from '../components/editCubeMsg.vue'
import L1 from '../components/layout/L1.vue'
import { getapi } from '../../tablet/store/fetch'
export default {
  components: {
    L1, editCube, RT
  },
  data () {
    return {
      page: '用量管理',
      data: null,
      line: null
    }
  },
  async mounted () {
    this.data = await getapi('textMessage')
    this.line = await getapi('message/number')
  }
}
</script>
<style lang="scss">
.editCubebox {
    .editCube {
      height: 100%;
      justify-content: flex-start;
      textarea {
        height: -webkit-fill-available;
        border: 1px solid #C4C4C4;
        border-radius: 3px;
        &:disabled {
          border: none;
          background-color: transparent;
        }
      }
    }
}
</style>
<style lang="scss" scoped>
.remainText {
  padding: 25px 62px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 78px;
  &>div{
    gap: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    &>div:nth-child(1) {
      color: var(--color-pri);
      font-size: 30px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      a {
        background-color: var(--color-checked);
        color: #FFFFFF;
        font-size: 18px;
        width: 130px;
        height: 40px;
        border-radius: 3px;
        margin-left: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;

      }
    }
    &>div:nth-child(2) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      font-size: 24px;
      line-height: 180%;
      &>div>span {
        color: var(--highlight);
      }
    }
  }
}
.editCubebox {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 91px;
  padding: 0 45px;
  position: relative;
  height: 100%;
  hr {
    background-color: #CACACA;
    top: 0;
    position: absolute;
    bottom: 0;
    width: 1px;
    left: 0;
    right: 0;
    border: none;
    box-sizing: border-box;
  }
  &>div {
    padding-block: 45px;
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 50px;
  }
}
</style>
